import { render } from "./Servizio.vue?vue&type=template&id=37645277"
import script from "./Servizio.vue?vue&type=script&lang=js"
export * from "./Servizio.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__